module.exports = __webpack_public_path__ + "static/media/ErikHuynhResume.de7e0f8e.pdf";